import {Resource} from "constants/global";

export function hasAuth(authority: number[], authIdList: Resource[] ): boolean {
  return authIdList.some(item => authority.includes(item));
}
